import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import SimpleBar from 'simplebar-react';
import DialogEditImageName from '../Dialog/DialogEditImageName';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import UploadImage from '../Dialog/UploadImage';
import DialogCarousel from 'src/components/medicalSchema/ImageManagement/Dialog/DialogCarousel';
import Rows from './images/Rows';
// import DialogCompare from './images/dialog/DialogCompare';

const defaultEditName = {
  id: '',
  patientid: '',
  filename: '',
};

const Images = (props: any) => {
  const imagesProps = props.images || [];
  const patient = props.patient || null;
  const [openImage, setOpenImage] = useState(false);
  const [checked, setChecked] = useState(false);
  const [images, setImages] = useState([...imagesProps]);
  const [editFileName, setEditFileName] = useState(defaultEditName);
  const [openEditFileName, setOpenEditFileName] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogCarousel, setOpenDialogCarousel] = useState(false);
  const [view, setView] = useState(false);
  const [viewType, setViewType] = useState(false);
  const [imageGadgets, setImageGadgets] = useState(null);
  // const [openDialogCompare, setOpenDialogCompare] = useState(false);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleImageClick = () => {
    setOpenDialogCarousel(true);
  };

  const handleCloseCarousel = () => {
    setOpenDialogCarousel(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const groupImages = (images: any) => {
    const group = images.reduce((result: any, row: any) => {
      if (!result.hasOwnProperty(row.date)) {
        result[row.date] = [];
      }
      result[row.date].push(row);
      return result;
    }, []);
    setImageGadgets(group);
  };

  useEffect(() => {
    if (checked) {
      setImages([...imagesProps]);
      groupImages(imagesProps);
    } else {
      const data = imagesProps.filter((image: any) => image.deleted === 0);
      setImages(data);
      groupImages(data);
    }
    // eslint-disable-next-line
  }, [checked, props.images]);

  const handleCloseImage = () => {
    setOpenImage(false);
  };

  const handleOpenUpload = () => {
    setOpenImage(true);
  };

  const handleEditName = (id: string, name: string) => {
    setEditFileName({
      id: id,
      patientid: patient?.id,
      filename: name.split('.').slice(0, -1).join('.'),
    });
    setOpenEditFileName(true);
  };

  const handleCloseDialogEditFilename = () => {
    setOpenEditFileName(false);
    setEditFileName(defaultEditName);
  };

  const handleSaveEditFilename = () => {
    setOpenEditFileName(false);
    setEditFileName(defaultEditName);

    try {
      const token = getToken();
      getAPI(
        `/patient/get-gadget?patientid=${patient?.id}&type=image&token=${token}`
      ).then((res) => {
        if (res.code === 200) {
          if (checked) {
            setImages(res.data.images);
          } else {
            const data = res.data.images.filter(
              (image: any) => image.deleted === 0
            );
            setImages(data);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleView = () => {
    setView(!view);
  };

  const handleChangeView = () => {
    setViewType(!viewType);
  };

  return (
    <>
      <Stack
        width={'100%'}
        className={`${view ? 'showAll' : 'showLess'}`}
        sx={{
          backgroundColor: 'primary.light',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          '&.showAll .simplebar-root': { maxHeight: 'max-content !important' },
          '&.showLess .simplebar-root': { maxHeight: '234px !important' },
        }}
        borderTop={'4px solid #656D78'}
        mb={'16px'}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          p={'5px 16px'}
          height={'48px'}
        >
          <Typography fontSize={'14px'} fontWeight={700}>
            画像
          </Typography>
          <Stack direction={'row'} spacing={'8px'}>
            <FormControlLabel
              value='start'
              control={
                <Switch color='primary' onChange={(e) => handleChange(e)} />
              }
              label={checked ? '削除を非表示' : '削除を表示'}
              labelPlacement='start'
              sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
            />
            <Box
              component={'img'}
              src={`/images/icons/ic-arrow-${view ? 'up' : 'down'}.svg`}
              alt='edit'
              sx={{ cursor: 'pointer' }}
              width={'24px'}
              onClick={handleView}
            />
            <Box
              component={'img'}
              src='/images/icons/ic-plus.svg'
              alt='edit'
              sx={{ cursor: 'pointer' }}
              width={'24px'}
              onClick={handleOpenUpload}
            />
            <Box
              component={'img'}
              src='/images/icons/ic-drag-drop.svg'
              alt='edit'
              sx={{ cursor: 'pointer' }}
              width={'24px'}
              onClick={handleChangeView}
            />
          </Stack>
        </Stack>
        <SimpleBar style={{ maxHeight: '234px' }} className='simplebar-root'>
          {viewType ? (
            <TableContainer component={Paper}>
              <Table aria-label='simple table'>
                <TableHead
                  sx={{
                    '& th': { py: '4px', fontSize: '14px', fontWeight: 700 },
                  }}
                >
                  <TableRow>
                    <TableCell>登録日</TableCell>
                    <TableCell>ファイル名</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  sx={{ '& td': { fontSize: '14px', fontWeight: 400 } }}
                >
                  {images &&
                    images.map((row: any, index: number) => (
                      <TableRow
                        hover
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleImageClick()}
                        >
                          {row.date}
                        </TableCell>
                        <TableCell
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleImageClick()}
                        >
                          {row.name}
                        </TableCell>
                        <TableCell
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleImageClick()}
                        >
                          <Box
                            component={'img'}
                            src={row.preview}
                            alt='edit'
                            sx={{ cursor: 'pointer' }}
                            width={'40px'}
                            height={'auto'}
                            onMouseEnter={(event) => handlePopoverOpen(event)}
                            onMouseLeave={handlePopoverClose}
                          />
                          <Popover
                            id='mouse-over-popover'
                            sx={{
                              pointerEvents: 'none',
                              '& .MuiPaper-root.MuiPopover-paper': {
                                boxShadow: 'none',
                                height: '150px',
                                overflowY: 'hidden',
                              },
                            }}
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Box
                              component='img'
                              src={row.preview}
                              alt='face-patient'
                              width={'200px'}
                              height={'150px'}
                              sx={{ objectFit: 'contain' }}
                              border={'4px solid #F3F3F3'}
                            ></Box>
                          </Popover>
                        </TableCell>
                        <TableCell>
                          <Box
                            component={'img'}
                            src='/images/icons/ic-edit.svg'
                            alt='edit'
                            sx={{ cursor: 'pointer' }}
                            width={'24px'}
                            onClick={() => handleEditName(row.id, row.name)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Rows imageGadgets={imageGadgets} />
          )}
        </SimpleBar>
      </Stack>
      <UploadImage
        open={openImage}
        onClose={handleCloseImage}
        patient={patient || null}
      />
      <DialogEditImageName
        open={openEditFileName}
        onClose={handleCloseDialogEditFilename}
        onSave={handleSaveEditFilename}
        editName={editFileName}
      />

      <DialogCarousel
        openCarousel={openDialogCarousel}
        handleCloseCarousel={handleCloseCarousel}
        imageList={imagesProps}
      />

      {/* <DialogCompare
        openDialogCompare={openDialogCompare}
        setCloseDialogCompare={setCloseDialogCompare}
      ></DialogCompare> */}
    </>
  );
};

export default Images;
